import { PayloadAction } from "@reduxjs/toolkit";
import { put, takeLatest } from "redux-saga/effects";
import { modalActions } from "store/sagas/modal/modal.actions";
import { closeModal, openModal } from "store/slices/modal/slice";
import { ModalProps } from "types/modal";

function* openModalSaga(action: PayloadAction<ModalProps>) {
  yield put(openModal(action.payload));
}

function* closeModalSaga() {
  yield put(closeModal());
}

export default function* modalSaga() {
  yield takeLatest(modalActions.OPEN_MODAL, openModalSaga);
  yield takeLatest(modalActions.CLOSE_MODAL, closeModalSaga);
}
